(function (root) {
  'use strict';
  var ALPHABET = '0123456789abcdefghijklmnopqrstuv';
  var LEGACY_NAMES = ['Cream', 'Navy', 'Gold', 'White', 'Black', 'Red', 'Orange', 'Yellow', 'Green', 'Teal', 'Blue', 'Purple', 'Pink', 'Brown', 'Grey', 'Light grey'];
  var DRAFT_PREFIX = 'wc_commission_draft_v1:', DRAFT_WINDOW = 86400000, MAX_DRAFT = 62500;
  var safeInteger = function (n) { return Number.isSafeInteger(n) && n >= 0; };
  var token = function (s) { return typeof s === 'string' && /^[A-Za-z0-9_-]{8,128}$/.test(s); };
  function uuid() {
    if (root.crypto && root.crypto.randomUUID) return root.crypto.randomUUID();
    return 's' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2) + '_' + Math.random().toString(36).slice(2);
  }
  function decode(ch) { return ch === '.' ? -1 : ALPHABET.indexOf(ch); }
  function encode(p) { return p.op === 'erase' ? '.' : ALPHABET.charAt(p.c); }
  function apply(grid, pixels, width) {
    var cells = grid.split('');
    pixels.forEach(function (p) { cells[p.y * width + p.x] = encode(p); });
    return cells.join('');
  }
  function validPixels(pixels, w, h, size, erase) {
    return Array.isArray(pixels) && pixels.length > 0 && pixels.every(function (p) {
      return p && safeInteger(p.x) && p.x < w && safeInteger(p.y) && p.y < h &&
        (p.op === 'erase' ? erase && p.c === undefined : p.op === undefined && safeInteger(p.c) && p.c < size);
    });
  }
  function snapshot(d) {
    if (!d || d.w !== 250 || d.h !== 250 ||
        !safeInteger(d.season) || d.season < 1 || !safeInteger(d.painted) || !Array.isArray(d.palette) || typeof d.grid !== 'string' || d.grid.length !== d.w * d.h ||
        !d.palette.every(function (c) { return typeof c === 'string' && /^#[0-9a-f]{6}$/i.test(c); })) return false;
    if (d.protocol === 2) {
      if (d.schema !== 2 || !token(d.epoch) || d.epoch.length > 96 || !safeInteger(d.revision) ||
          d.encoding !== 'base32-v1' || d.alphabet !== ALPHABET || d.palette.length !== 32 ||
          !Array.isArray(d.paletteNames) || d.paletteNames.length !== 32 ||
          !d.paletteNames.every(function (n) { return typeof n === 'string' && n.length > 0 && n.length < 80; }) ||
          !safeInteger(d.occupied) || d.occupied > d.w * d.h || !d.capabilities || d.capabilities.paletteSize !== 32 ||
          ['erase', 'events', 'presence'].some(function (key) { return typeof d.capabilities[key] !== 'boolean'; })) return false;
      return /^[.0-9a-v]+$/.test(d.grid);
    }
    // Old servers did not identify their protocol. Only the complete, known legacy shape is safe.
    return (d.protocol === undefined || d.protocol === 1) &&
      (d.encoding === undefined || d.encoding === 'hex-v1') &&
      (d.alphabet === undefined || d.alphabet === ALPHABET.slice(0, 16)) &&
      d.palette.length === 16 && /^[.0-9a-f]+$/.test(d.grid);
  }
  function element(tag, text, attrs) {
    var el = document.createElement(tag);
    if (text) el.textContent = text;
    Object.keys(attrs || {}).forEach(function (k) { el.setAttribute(k, attrs[k]); });
    return el;
  }
  function styles() {
    if (document.getElementById('wc-commission-style')) return;
    var el = element('style', '', { id: 'wc-commission-style' });
    el.textContent = '.wcc-tools{font:inherit;color:inherit}.wcc-tools [hidden],.wcc-state [hidden]{display:none!important}'
      + '.wcc-state{display:flex;flex-wrap:wrap;align-items:center;gap:4px 10px;font-size:12px;line-height:1.35}.wcc-state>:empty{display:none}'
      + '.wcc-presence{display:inline-flex;align-items:center;gap:6px;font-weight:700;white-space:nowrap}.wcc-presence:not([data-presence]){display:none}'
      + '.wcc-presence::before{content:"";width:7px;height:7px;border-radius:50%;background:#9aa5aa;flex:0 0 auto}'
      + '.wcc-state[data-transport=live] .wcc-presence::before{background:#2fbf71}.wcc-state[data-transport=poll] .wcc-presence::before{background:#e0a800}'
      + '.wcc-state[data-transport=reconnecting] .wcc-presence::before{background:#e07b00}'
      + '.wcc-trace-controls{display:flex;flex-wrap:wrap;gap:8px;align-items:center}.wcc-trace-body{display:flex;flex-direction:column;gap:8px}'
      + '.wcc-tools button,.wcc-erase{min-height:var(--wcc-ctl,40px);border:1px solid currentColor;border-radius:7px;background:transparent;color:inherit;padding:6px 10px;font:inherit;cursor:pointer}'
      + '.wcc-tools button:disabled,.wcc-erase:disabled{opacity:.5;cursor:not-allowed}.wcc-tools button[aria-pressed=true],.wcc-erase[aria-pressed=true]{background:#16283f;color:#fff}'
      + '.wcc-tools input[type=range]{width:100px;max-width:100%;vertical-align:middle}.wcc-tools input[type=file]{max-width:100%;font:inherit}'
      + '.wcc-tools details{position:static;max-height:none;overflow:visible}.wcc-tools summary{cursor:pointer;min-height:36px;display:list-item}'
      + '.wcc-trace{position:absolute;left:0;top:0;pointer-events:none;z-index:1;transform-origin:0 0;max-width:none!important;max-height:none!important;user-select:none}'
      + '.wcc-tools :focus-visible,.wcc-erase:focus-visible{outline:3px solid #378add;outline-offset:2px}'
      + '.wcc-palette{display:grid;grid-template-columns:repeat(auto-fill,minmax(var(--wcc-sw,32px),1fr));gap:var(--wcc-gap,6px);padding:0}'
      + '.wcc-palette button{display:block;width:100%;height:var(--wcc-sw,32px);min-width:0;min-height:0;padding:0;border:2px solid transparent;border-radius:6px;box-sizing:border-box;cursor:pointer}'
      + '.wcc-palette button[aria-pressed=true]{outline:2px solid currentColor;outline-offset:1px}.wcc-palette button:focus-visible{outline:3px solid #378add;outline-offset:2px}';
    (document.head || document.body).appendChild(el);
  }

  function create(opts) {
    styles();
    var base = null, acknowledgements = [], heldBatch = null, frozen = false, retryUntil = 0, readOrdinal = 0, acceptedRead = 0;
    var stream = null, streamReady = false, lastSync = 0, lastPaint = 0, selected = 1, erase = false;
    /* THE STREAM IS SUPERVISED, NOT TRUSTED (2026-09-14). Josh, two devices: "it was doing good for a
       while and then it got out of sync and i have to eventually refresh ... for the canvas to sync".
       What was reproduced (headless Chrome, two clients, the page frozen and thawed through CDP's
       lifecycle override): the client logged `visibilitychange` hidden and never a visible one, so
       it sat on "Reconnecting" for good — reconnection only ever happened on the visible event, and
       the 30-second poll was gated on document.hidden too. Whether a real iPhone leaves
       document.hidden stale after a home-screen resume is ASSUMED, not measured: no phone trace
       exists yet, and until one does the phone's own event sequence is unknown. So the client
       does not trust document.hidden alone. A page is visible when the browser says so, OR when a
       touch or a key has arrived since the last hidden/pagehide (held, not timed — a person
       watching after one tap is still watching), OR when a frame was painted in the last few
       seconds (requestAnimationFrame runs only on a painted document; the phone put down beside
       the laptop to WATCH gets no touch, but it gets frames). A stream the browser abandoned
       (readyState CLOSED after a non-200 answer — EventSource never retries those) or one that has
       gone quiet past the server's own 50-second lifetime is replaced by a watchdog, with backoff;
       while the stream is being retried the poll runs every 10 seconds, not 30 (see pollEvery for
       when a refused stream relaxes it back); and a failed read backs off
       the way a failed stream does, so twenty people behind one office NAT do not each hammer the
       read budget every 5 seconds once it is exhausted (the reviewers' sweep: 16 co-located viewers
       collapsed it for good; the old client tolerated 30). */
    var streamSignalAt = 0, streamFailures = 0, streamRetryAt = 0, streamTroubleAt = 0;
    var readFailures = 0, readRetryAt = 0, lastReadAt = 0, proven = false, lastFrame = 0;
    var STREAM_STALL_MS = 75000, STREAM_RECONNECT_GRACE_MS = 10000, POLL_LIVE_MS = 30000, POLL_DEGRADED_MS = 10000;
    var READ_BACKOFF_MS = 10000, READ_BACKOFF_MAX_MS = 60000, FRAME_EVERY_MS = 1000, FRAME_PROVES_VISIBLE_MS = 4000;
    function visible() { return !document.hidden || proven || Date.now() - lastFrame < FRAME_PROVES_VISIBLE_MS; }
    // One painted frame a second, asked for through a timer so the harness's synchronous
    // requestAnimationFrame cannot recurse. Frames stop the moment the document is not painted.
    function beat() { lastFrame = Date.now(); setTimeout(pulse, FRAME_EVERY_MS); }
    function pulse() { root.requestAnimationFrame(beat); }
    // A read is worth issuing when the board is older than `age`, no read was ASKED that recently
    // (an in-flight or failed read counts), and a failed read's backoff has passed.
    function readDue(age) { var now = Date.now(); return now >= readRetryAt && now - lastSync >= age && now - lastReadAt >= age; }
    /* How often the poll reads. Live (or a paused draft, which has no stream by design): 30 s, the
       safety net under a delivering stream. Stream down: 10 s — but only while the stream is being
       retried. Refused three times running (backoff 4, 8, 16 s; next 32) means this IP is over its
       four stream leases or the endpoint is down, and every viewer behind that NAT is in the same
       state, sharing one 60/min read budget: at 10 s the budget filled at twelve viewers in the
       reviewers' sweep, where the old 30 s timer carried thirty. So a refused client relaxes to
       30 s, which the label says. `ready` resets the count. */
    function pollEvery() { return !isLive() ? 0 : streamReady || frozen || streamFailures >= 3 ? POLL_LIVE_MS : POLL_DEGRADED_MS; }
    var selectedPalette = '', trace = null, adjusting = false, tracePointer = null, traceLoad = 0, tracePendingUrl = null;
    var api = opts.api, origin = api.replace(/\/api\/canvas$/, '');
    var journalKey = DRAFT_PREFIX + uuid(), journalSource = null, draftRevision = null, draftNonce = null, draftIssued = null;
    var recoveryChecked = false, recoveryDurable = false, recoveryVerifying = false, recoveryChoices = [];
    var expectations = new WeakMap(), confirmedBatch = null;
    // The page may hand the status row and the Erase button their own homes (opts.slots), so a
    // section can lay the tools out as a rail or a dock without re-parenting after the fact;
    // anything without a slot still lands in the toolbar. Every id the page reads stays put.
    var toolbar = opts.toolbar, slots = opts.slots || {};
    function host(k) { var el = slots[k]; return el && el.nodeType === 1 ? el : toolbar; }
    var transportEl = element('span', 'Loading board…', { class: 'wcc-transport' }), presenceEl = element('span', 'Presence unavailable', { class: 'wcc-presence' });
    var stateEl = element('div', '', { class: 'wcc-state', role: 'status' });
    stateEl.appendChild(transportEl); stateEl.appendChild(presenceEl); host('state').appendChild(stateEl);
    var draftEl = element('span', '', { class: 'wcc-draft' }), discardBtn = element('button', 'Discard local draft', { type: 'button' });
    discardBtn.hidden = true; stateEl.appendChild(draftEl); toolbar.appendChild(discardBtn);
    toolbar.className += ' wcc-tools';
    var eraseBtn = element('button', 'Erase', { type: 'button', 'aria-pressed': 'false', class: 'wcc-erase' });
    eraseBtn.disabled = true; eraseBtn.title = 'Erase needs the upgraded board'; host('erase').appendChild(eraseBtn);
    var details = element('details', '', { class: 'wcc-trace-box' }), summary = element('summary', 'Trace image');
    details.appendChild(summary); toolbar.appendChild(details);
    var traceBody = element('div', '', { class: 'wcc-trace-body' }); details.appendChild(traceBody);
    var tools = element('div', '', { class: 'wcc-trace-controls' }); traceBody.appendChild(tools);
    var fileLabel = element('label', 'Choose image '), file = element('input', '', { type: 'file', accept: 'image/png,image/jpeg,image/webp,image/gif', 'aria-label': 'Private tracing image' });
    fileLabel.appendChild(file); tools.appendChild(fileLabel);
    var adjust = element('button', 'Adjust image', { type: 'button', 'aria-pressed': 'false' }); adjust.disabled = true;
    var scaleLabel = element('label', 'Scale '), scale = element('input', '', { type: 'range', min: '10', max: '300', value: '100', 'aria-label': 'Tracing image scale' });
    scale.value = '100'; scale.disabled = true; scaleLabel.appendChild(scale);
    var opacityLabel = element('label', 'Opacity '), opacity = element('input', '', { type: 'range', min: '0', max: '100', value: '40', 'aria-label': 'Tracing image opacity' });
    opacity.value = '40'; opacity.disabled = true; opacityLabel.appendChild(opacity);
    var remove = element('button', 'Remove image', { type: 'button' }); remove.disabled = true;
    [adjust, scaleLabel, opacityLabel, remove].forEach(function (el) { tools.appendChild(el); });
    var traceNote = element('span', 'Private — only you can see it. Not uploaded, shared, saved, or included in artwork exports.'); traceBody.appendChild(traceNote);
    function say(message) { opts.tell(message); }
    function isLive() { return !!base && base.protocol === 2; }
    function hasDraft() { return !!heldBatch || opts.hasDraft(); }
    function status() {
      // A read in backoff must not be labelled with a cadence it will not keep.
      var unavailable = readRetryAt > Date.now();
      transportEl.textContent = frozen ? 'Draft paused — no automatic replay' : !base ? 'Loading board…' :
        !isLive() ? (unavailable ? 'Auto refresh · connection unavailable' : 'Auto refresh · every 5 seconds') :
        streamReady ? 'Live updates' : unavailable ? 'Reconnecting · board unavailable' : 'Reconnecting · refreshing every ' + Math.round(pollEvery() / 1000) + ' seconds';
      stateEl.setAttribute('data-transport', frozen ? 'paused' : !base ? 'loading' : !isLive() ? 'poll' : streamReady ? 'live' : 'reconnecting');
    }
    /* Presence is a count of people, said like one: "Only you here", "5 here", "5 here · 1 painting".
       The full triple stays as the tooltip; when it is unknown the pill hides rather than reading
       "unavailable" next to the art (2026-09-14: Josh could not find the presence count in the old
       "Active sessions: 2 · placing: 0 · watching: 2" line). */
    function showPresence(d) {
      if (!d) { presenceEl.textContent = 'Presence unavailable'; presenceEl.removeAttribute('data-presence'); presenceEl.removeAttribute('title'); return; }
      presenceEl.textContent = d.sessions <= 1 ? 'Only you here' : d.sessions + ' here' + (d.placing ? ' · ' + d.placing + ' painting' : '');
      presenceEl.setAttribute('title', 'Active sessions: ' + d.sessions + ' · placing: ' + d.placing + ' · watching: ' + d.watching);
      presenceEl.setAttribute('data-presence', 'on');
    }
    function freeze(reason) {
      frozen = true; eraseBtn.disabled = true; status();
      disconnect(); discardBtn.hidden = false;
      draftEl.textContent = reason;
      say(reason + ' ' + (recoveryDurable ? 'Your local draft is saved on this browser.' : 'Your unconfirmed tiles are kept only in this tab; do not close it.') + ' It will not overwrite newer work or a different board.');
      notify();
    }
    function currentRevision() { return acknowledgements.reduce(function (n, a) { return Math.max(n, a.revision); }, base.revision); }
    function plainPixel(p) { return p.op === 'erase' ? { x: p.x, y: p.y, op: 'erase' } : { x: p.x, y: p.y, c: p.c }; }
    function forgetSource() {
      if (!journalSource) return;
      // Another still-open tab may have added edits since this snapshot. Never erase its newer journal.
      if (root.localStorage.getItem(journalSource.key) === journalSource.raw) root.localStorage.removeItem(journalSource.key);
      journalSource = null;
    }
    function persist() {
      if (frozen || !base || !isLive() || base.capabilities.recovery !== true || !opts.getDraft) return;
      var pixels = opts.getDraft();
      try {
        if (!pixels.length && !heldBatch) {
          root.localStorage.removeItem(journalKey); forgetSource();
          draftRevision = draftNonce = draftIssued = null; recoveryDurable = false;
          draftEl.textContent = ''; return;
        }
        if (pixels.length > MAX_DRAFT) throw new Error('draft too large');
        if (draftRevision === null) draftRevision = currentRevision();
        if (!draftNonce) { draftNonce = uuid(); draftIssued = Date.now(); }
        var record = { version: 1, api: api, actor: opts.actor, epoch: base.epoch, season: base.season,
          revision: draftRevision, batchId: draftNonce, issuedAt: draftIssued, pending: pixels.map(plainPixel),
          expected: pixels.map(function (p) { return expectations.get(p); }).join(''),
          held: heldBatch ? { body: heldBatch.body, revision: heldBatch.revision,
            indices: heldBatch.pixels.map(function (p) { return pixels.indexOf(p); }) } : null };
        var raw = JSON.stringify(record);
        root.localStorage.setItem(journalKey, raw);
        if (root.localStorage.getItem(journalKey) !== raw) throw new Error('draft write unconfirmed');
        recoveryDurable = true;
        draftEl.textContent = 'Unconfirmed tiles saved privately on this browser';
      } catch (e) {
        recoveryDurable = false;
        draftEl.textContent = 'Local draft storage unavailable — keep this tab open until saved';
      }
    }
    function validDraft(d) {
      if (!d || d.version !== 1 || d.api !== api || d.actor !== opts.actor || !token(d.actor) || d.actor.length > 64 ||
          !token(d.epoch) || d.epoch.length > 96 || !safeInteger(d.season) || d.season < 1 || !safeInteger(d.revision) ||
          !token(d.batchId) || !safeInteger(d.issuedAt) || d.issuedAt < 1 ||
          !validPixels(d.pending, 250, 250, 32, true) || d.pending.length > MAX_DRAFT ||
          d.pending.some(function (p) { return JSON.stringify(p) !== JSON.stringify(plainPixel(p)); })) return false;
      if (typeof d.expected !== 'string' || d.expected.length !== d.pending.length || /[^.0-9a-v]/.test(d.expected)) return false;
      if (!d.held) return true;
      var h = d.held, b = h.body;
      return !!b && b.protocol === 2 && b.actor === d.actor && b.epoch === d.epoch && b.season === d.season &&
        Object.keys(b).every(function (key) { return ['protocol', 'actor', 'epoch', 'season', 'batchId', 'issuedAt', 'pixels', 'baseRevision', 'expected'].indexOf(key) !== -1; }) &&
        token(b.batchId) && safeInteger(b.issuedAt) && b.issuedAt > 0 && safeInteger(h.revision) &&
        (b.baseRevision === undefined || safeInteger(b.baseRevision) && h.revision === b.baseRevision) &&
        Array.isArray(b.pixels) && typeof b.expected === 'string' && b.expected.length === b.pixels.length && !/[^.0-9a-v]/.test(b.expected) &&
        validPixels(b.pixels, 250, 250, 32, true) && b.pixels.length <= 500 &&
        b.pixels.every(function (p) { return JSON.stringify(p) === JSON.stringify(plainPixel(p)); }) && Array.isArray(h.indices) && h.indices.length === b.pixels.length &&
        h.indices.every(function (n, i) { return n === -1 || safeInteger(n) && n < d.pending.length && JSON.stringify(plainPixel(d.pending[n])) === JSON.stringify(plainPixel(b.pixels[i])); });
    }
    function restore(entry) {
      if (hasDraft()) return;
      var d = entry.d;
      journalSource = entry; recoveryDurable = true;
      recoveryChoices.forEach(function (el) { el.remove(); }); recoveryChoices = [];
      // Keep stale drafts on disk but do not draw their overlay over the current painter's work.
      if (!isLive() || base.capabilities.recovery !== true || d.epoch !== base.epoch || d.season !== base.season) { freeze('A saved draft belongs to a different or unavailable board.'); return; }
      var issued = d.held ? d.held.body.issuedAt : d.issuedAt;
      if (Date.now() - issued >= DRAFT_WINDOW || issued > Date.now() + 60000) { freeze('A saved draft has expired and needs review.'); return; }
      if (!d.held && d.pending.some(function (p, i) { return base.grid[p.y * base.w + p.x] !== d.expected[i]; })) { freeze('Someone changed a square targeted by these offline edits.'); return; }
      var pixels = d.pending.map(plainPixel);
      pixels.forEach(function (p, i) { expectations.set(p, d.expected[i]); });
      draftRevision = d.revision; draftNonce = d.batchId; draftIssued = d.issuedAt;
      if (d.held) {
        recoveryVerifying = base.revision > d.held.revision;
        var body = d.held.body;
        heldBatch = { body: body, json: JSON.stringify(body), protocol: 2, revision: d.held.revision,
          pixels: body.pixels.map(function (p, i) { return d.held.indices[i] < 0 ? plainPixel(p) : pixels[d.held.indices[i]]; }) };
      }
      opts.restoreDraft(pixels); persist();
      draftEl.textContent = 'Recovered local tiles — verifying the original save';
      // Never use matching colours as proof of a write. Reuse its original server receipt ID.
      setTimeout(function () { if (!frozen) opts.resumeDraft(); }, 0);
    }
    function recover() {
      if (recoveryChecked || !opts.getDraft || !opts.restoreDraft || !opts.resumeDraft) return;
      recoveryChecked = true;
      var entries = [], invalid = false;
      try {
        for (var i = 0; i < root.localStorage.length; i++) {
          var key = root.localStorage.key(i);
          if (!key || key.indexOf(DRAFT_PREFIX) !== 0 || key === journalKey) continue;
          var raw = root.localStorage.getItem(key), d;
          if (!raw || raw.length > 4000000) { invalid = true; continue; }
          try { d = JSON.parse(raw); } catch (e) { invalid = true; continue; }
          if (d.api !== api || d.actor !== opts.actor) continue;
          if (!validDraft(d)) { invalid = true; continue; }
          entries.push({ key: key, raw: raw, d: d });
          if (entries.length >= 20) break;
        }
      } catch (e) { draftEl.textContent = 'Local draft storage unavailable — keep this tab open until saved'; return; }
      if (invalid) draftEl.textContent = 'An unreadable local draft was not replayed';
      if (entries.length === 1) { restore(entries[0]); return; }
      if (entries.length > 1) {
        draftEl.textContent = 'Multiple local drafts found — choose one to verify; none replayed';
        entries.forEach(function (entry, index) {
          var button = element('button', 'Recover draft ' + (index + 1) + ' (' + entry.d.pending.length + ' tiles)', { type: 'button' });
          button.addEventListener('click', function () { restore(entry); }); toolbar.appendChild(button); recoveryChoices.push(button);
        });
      }
    }
    discardBtn.addEventListener('click', function () {
      if (!frozen) return;
      try { root.localStorage.removeItem(journalKey); forgetSource(); }
      catch (e) { draftEl.textContent = 'Could not remove local draft — browser storage unavailable'; return; }
      heldBatch = null; draftRevision = draftNonce = draftIssued = null; frozen = false; recoveryDurable = false; recoveryVerifying = false;
      opts.restoreDraft([]); discardBtn.hidden = true; draftEl.textContent = ''; palette(); status(); opts.refresh();
      say('Only the local draft was discarded. No board tiles were changed.');
    });
    function decorated() {
      if (!base) return null;
      var grid = base.grid;
      acknowledgements.forEach(function (a) { if (a.revision > base.revision) grid = apply(grid, a.pixels, base.w); });
      return Object.assign({}, base, { grid: grid });
    }
    function notify() { var d = decorated(); if (d) opts.onRemote(d); }
    function showSelection() {
      Array.prototype.forEach.call(opts.palette.children, function (button) {
        var on = !erase && Number(button.getAttribute('data-colour')) === selected;
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) button.classList.add('sel'); else button.classList.remove('sel');
      });
      eraseBtn.setAttribute('aria-pressed', erase ? 'true' : 'false');
    }
    function palette() {
      if (!base) return;
      var names = base.paletteNames || LEGACY_NAMES;
      var key = JSON.stringify([base.palette, names]);
      if (key !== selectedPalette) {
        selectedPalette = key; opts.palette.innerHTML = '';
        opts.palette.classList.add('wcc-palette');
        base.palette.forEach(function (colour, index) {
          var button = element('button', '', { type: 'button', 'data-colour': String(index), 'aria-label': names[index] || ('Colour ' + (index + 1)), title: names[index] || colour });
          button.className = opts.swatchClass; button.style.background = colour;
          button.addEventListener('click', function () { selected = index; erase = false; showSelection(); say((names[index] || 'Colour') + ' selected.'); });
          opts.palette.appendChild(button);
        });
        if (selected >= base.palette.length) selected = 1;
      }
      eraseBtn.disabled = frozen || !isLive() || base.capabilities.erase !== true;
      if (eraseBtn.disabled) erase = false;
      eraseBtn.title = eraseBtn.disabled ? 'Erase needs the upgraded board' : 'Remove painted ink, not paint Cream';
      showSelection();
    }
    eraseBtn.addEventListener('click', function () { if (eraseBtn.disabled) return; erase = !erase; showSelection(); say(erase ? 'Erase selected. Tap a square to remove its ink.' : 'Paint selected.'); });

    // The label follows the stream down: a page with no stream must never read "Live updates"
    // (2026-09-14 reviewers: after a stale hidden it did, for as long as nobody touched the phone).
    function disconnect() { if (stream) stream.close(); stream = null; streamReady = false; streamTroubleAt = 0; status(); }
    function connect() {
      if (!isLive() || base.capabilities.events !== true || typeof root.EventSource !== 'function' || !visible() || frozen) return;
      // Alive or still connecting: leave it. CLOSED means the browser gave up (a non-200 answer) and
      // will never retry on its own; that one is replaced, with a backoff so a 429 is not hammered.
      if (stream && stream.readyState !== 2) return;
      if (stream) disconnect();
      if (Date.now() < streamRetryAt) return;
      try { stream = new root.EventSource(origin + '/api/canvas-events?protocol=2'); } catch (e) { streamReady = false; status(); return; }
      var current = stream;
      streamSignalAt = Date.now();
      stream.addEventListener('ready', function () { if (stream !== current) return; streamReady = true; streamSignalAt = Date.now(); streamFailures = 0; streamRetryAt = 0; streamTroubleAt = 0; opts.refresh(); });
      stream.addEventListener('patch', function (event) {
        if (stream !== current || !base || frozen) return;
        streamSignalAt = Date.now();
        var patch; try { patch = JSON.parse(event.data); } catch (e) { streamReady = false; status(); opts.refresh(); return; }
        if (!patch || patch.type !== 'patch' || patch.protocol !== 2 || patch.epoch !== base.epoch || patch.season !== base.season) {
          streamReady = false; status(); opts.refresh(); return;
        }
        if (!safeInteger(patch.revision)) { streamReady = false; status(); opts.refresh(); return; }
        if (patch.revision <= base.revision) return;
        if (patch.revision !== base.revision + 1 || !validPixels(patch.pixels, base.w, base.h, 32, true) || !safeInteger(patch.occupied) || !safeInteger(patch.painted)) {
          streamReady = false; status(); opts.refresh(); return;
        }
        base = Object.assign({}, base, { grid: apply(base.grid, patch.pixels, base.w), revision: patch.revision, occupied: patch.occupied, painted: patch.painted });
        acknowledgements = acknowledgements.filter(function (a) { return a.revision > base.revision; });
        lastSync = Date.now(); streamReady = true; status(); notify();
      });
      stream.addEventListener('error', function () {
        if (stream !== current) return;
        if (current.readyState === 2) { streamReady = false; streamFailures++; streamRetryAt = Date.now() + Math.min(60000, 2000 * Math.pow(2, streamFailures)); status(); return; }
        // CONNECTING: the browser is retrying by itself. The server ends every stream at 50 s and
        // says `retry: 2000`, so this fires on every healthy cycle and `ready` follows in ~2 s. That
        // is not degraded — calling it so cost a third read per cycle and blinked the chip orange
        // once a minute. It becomes degraded only if the retry has not come back within the grace.
        if (!streamTroubleAt) streamTroubleAt = Date.now();
      });
    }
    /* The watchdog: every 5 s while visible. A dead or silent stream is replaced; the poll fills the
       gap. `ready` arrives on every (re)connect — about every 52 s from a healthy stream — so 75 s of
       silence means the socket died without telling us (the OS does that to a resumed page). A page
       that is NOT visible keeps no stream: a tab born hidden, or one whose frames stopped without a
       hidden event, must not hold one of the four per-IP stream leases the visible phone needs. */
    function supervise() {
      if (!visible()) { if (stream) disconnect(); return; }
      if (isLive() && base.capabilities.events === true && !frozen) {
        if (stream && stream.readyState === 2) connect();
        else if (stream && Date.now() - streamSignalAt > STREAM_STALL_MS) { disconnect(); connect(); }
        else if (!stream) connect();
        else if (streamReady && streamTroubleAt && Date.now() - streamTroubleAt > STREAM_RECONNECT_GRACE_MS) { streamReady = false; status(); }
      }
      // A frozen draft has no stream by design (freeze() disconnects, connect() refuses); the board
      // under it still refreshes, at the live cadence — that is how the old 30 s timer behaved, and
      // a paused draft going static until Discard was the reviewers' two-device repro.
      if (readDue(pollEvery())) opts.refresh();
    }
    // `force` for a real visibility return (the visible event, or the first touch on a page that
    // thought it was hidden): reconnect, read, announce. focus/pageshow/online fire freely on a
    // desktop (every alt-tab) and on hidden tabs (Wi-Fi back, cmd-click), so they prove nothing:
    // they reconnect only if the page is visible on its own evidence, read only when the board is
    // older than a few seconds, and leave presence to its 15 s timer. Before the first board has
    // landed there is nothing to resume — pageshow fires right after `load` on EVERY navigation,
    // and a second read then made the page discard the first.
    function resume(force) {
      if (!base || !visible()) return;
      connect();
      if (force) { opts.refresh(); presence(); }
      else if (readDue(5000)) opts.refresh();
    }

    var session = uuid(), presenceSequence = 0, presenceBusy = false, presenceGeneration = 0, presenceController = null;
    function presence(activity) {
      if (!isLive() || base.capabilities.presence !== true || frozen || (!visible() && activity !== 'leave') || (presenceBusy && activity !== 'leave' && activity !== 'placing')) return;
      if (presenceController) presenceController.abort();
      presenceController = new AbortController();
      var controller = presenceController, generation = ++presenceGeneration;
      presenceBusy = true;
      var deadline = setTimeout(function () {
        if (generation !== presenceGeneration) return;
        presenceGeneration++; controller.abort(); presenceBusy = false; showPresence(null);
      }, 5000);
      fetch(origin + '/api/canvas-presence', { method: 'POST', signal: controller.signal, keepalive: activity === 'leave',
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ session: session, sequence: ++presenceSequence, activity: activity || (Date.now() - lastPaint < 5000 ? 'placing' : 'watching') }) })
        .then(function (r) { if (!r.ok) throw new Error('presence unavailable'); return r.json(); })
        .then(function (d) {
          if (generation !== presenceGeneration) return;
          if (!d || d.ok !== true || !safeInteger(d.sessions) || !safeInteger(d.placing) || !safeInteger(d.watching) || d.sessions !== d.placing + d.watching ||
              !safeInteger(d.asOf) || d.ttlMs !== 45000) throw new Error('presence unavailable');
          if (activity === 'leave') showPresence(null); else showPresence(d);
        }).catch(function () { if (generation === presenceGeneration) showPresence(null); })
        .finally(function () { clearTimeout(deadline); if (generation === presenceGeneration) presenceBusy = false; });
    }

    function traceView() {
      if (!trace) return;
      var view = opts.getView();
      trace.img.style.width = trace.width * trace.factor * view.scale + 'px';
      trace.img.style.height = trace.height * trace.factor * view.scale + 'px';
      trace.img.style.transform = 'translate(' + (view.x + trace.x * view.scale) + 'px,' + (view.y + trace.y * view.scale) + 'px)';
      trace.img.style.opacity = opacity.value / 100;
    }
    function endTrace() { if (tracePointer) { try { opts.stage.releasePointerCapture(tracePointer.id); } catch (e) {} } tracePointer = null; }
    function setAdjust(on) {
      endTrace(); opts.cancelPointer(); adjusting = !!trace && on;
      adjust.setAttribute('aria-pressed', adjusting ? 'true' : 'false');
      say(adjusting ? 'Adjusting private image. Drag it or use arrow keys on the board. Painting is paused.' : 'Painting enabled. Your tracing image stays private.');
    }
    function removeTrace() {
      traceLoad++; endTrace(); adjusting = false; opts.cancelPointer();
      if (tracePendingUrl) { root.URL.revokeObjectURL(tracePendingUrl); tracePendingUrl = null; }
      if (trace) { root.URL.revokeObjectURL(trace.url); trace.img.remove(); }
      trace = null; file.value = ''; adjust.disabled = scale.disabled = opacity.disabled = remove.disabled = true;
      adjust.setAttribute('aria-pressed', 'false');
    }
    file.addEventListener('change', function () {
      var chosen = file.files && file.files[0];
      if (!chosen) return;
      if (!/^image\/(png|jpeg|webp|gif)$/.test(chosen.type) || chosen.size > 20 * 1024 * 1024) { say('Choose a PNG, JPEG, WebP or GIF under 20 MB. Nothing was uploaded.'); file.value = ''; return; }
      removeTrace();
      var generation = ++traceLoad, url = root.URL.createObjectURL(chosen), img = element('img', '', { class: 'wcc-trace', alt: '', 'aria-hidden': 'true', draggable: 'false' });
      tracePendingUrl = url; remove.disabled = false;
      // Object URLs are local. No filename, bytes, image URL or tracing coordinates enter transport.
      img.onload = function () {
        if (generation !== traceLoad) { root.URL.revokeObjectURL(url); return; }
        tracePendingUrl = null;
        if (!img.naturalWidth || !img.naturalHeight) { root.URL.revokeObjectURL(url); say('That image could not be decoded.'); return; }
        var size = opts.getSize(), view = opts.getView(), visible = opts.stage.getBoundingClientRect();
        var factor = Math.min(size.w * 0.7 / img.naturalWidth, size.h * 0.7 / img.naturalHeight,
          visible.width * 0.8 / view.scale / img.naturalWidth, visible.height * 0.8 / view.scale / img.naturalHeight);
        var width = img.naturalWidth * factor, height = img.naturalHeight * factor;
        trace = { url: url, img: img, width: width, height: height, factor: 1,
          x: (visible.width / 2 - view.x) / view.scale - width / 2, y: (visible.height / 2 - view.y) / view.scale - height / 2 };
        scale.value = '100'; opacity.value = '40'; adjust.disabled = scale.disabled = opacity.disabled = remove.disabled = false;
        opts.stage.appendChild(img); traceView(); say('Private tracing image loaded. Use Adjust image to move it; it will not be shared or exported.');
      };
      img.onerror = function () { root.URL.revokeObjectURL(url); if (generation === traceLoad) { tracePendingUrl = null; say('That image could not be decoded. Nothing was uploaded.'); } };
      img.src = url;
    });
    adjust.addEventListener('click', function () { if (trace) setAdjust(!adjusting); });
    remove.addEventListener('click', function () { removeTrace(); say('Private tracing image removed.'); });
    scale.addEventListener('input', function () { if (trace) { trace.factor = Math.max(0.1, Math.min(3, Number(scale.value) / 100)); traceView(); } });
    opacity.addEventListener('input', traceView);
    opts.stage.addEventListener('pointerdown', function (e) {
      if (!adjusting || !trace || e.target.closest('button,a,input,select,textarea,[role="button"]')) return;
      if (tracePointer || e.isPrimary === false || e.button !== 0) { endTrace(); return; }
      tracePointer = { id: e.pointerId, x: e.clientX, y: e.clientY, ox: trace.x, oy: trace.y };
      try { opts.stage.setPointerCapture(e.pointerId); } catch (err) {}
      e.preventDefault();
    });
    opts.stage.addEventListener('pointermove', function (e) {
      if (!trace || !tracePointer || e.pointerId !== tracePointer.id) return;
      var view = opts.getView();
      trace.x = tracePointer.ox + (e.clientX - tracePointer.x) / view.scale;
      trace.y = tracePointer.oy + (e.clientY - tracePointer.y) / view.scale;
      traceView(); e.preventDefault();
    });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (event) { opts.stage.addEventListener(event, function (e) { if (tracePointer && e.pointerId === tracePointer.id) endTrace(); }); });
    opts.stage.addEventListener('keydown', function (e) {
      if (!adjusting || !trace || e.target !== opts.stage) return;
      var move = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] }[e.key];
      if (move) { var step = e.shiftKey ? 10 : 1; trace.x += move[0] * step; trace.y += move[1] * step; traceView(); e.preventDefault(); }
      if (e.key === 'Escape') { setAdjust(false); e.preventDefault(); }
    });

    var client = {
      live: isLive,
      overlayAllowed: function () { return !frozen && !recoveryVerifying; },
      frozen: function () { return frozen; },
      adjusting: function () { return adjusting; },
      traceView: traceView,
      pauseTrace: function () { endTrace(); adjusting = false; adjust.setAttribute('aria-pressed', 'false'); },
      readUrl: function (actor, customer) { return api + '?protocol=2&actor=' + encodeURIComponent(actor) + (customer ? '&cust=' + encodeURIComponent(customer) : ''); },
      // The ticket carries when the read was asked: a snapshot is as old as its request, not as
      // its arrival, and measuring the poll from the arrival slipped every deadline to the next
      // 5 s tick (15 s in "degraded", 35 s live) because the answer always lands after the tick.
      beginRead: function () { lastReadAt = Date.now(); return { ordinal: ++readOrdinal, epoch: base && base.epoch, season: base && base.season, issuedAt: lastReadAt }; },
      read: function (d, ticket) {
        if (ticket && (ticket.ordinal < acceptedRead ||
            ticket.season !== null && base && (ticket.epoch !== base.epoch || ticket.season !== base.season))) return null;
        if (!snapshot(d)) { transportEl.textContent = 'Board unavailable — retrying'; throw new Error('invalid board snapshot'); }
        if (isLive() && d.protocol !== 2) { freeze('This upgraded board is no longer available.'); return null; }
        if (base && (base.protocol === 2 && d.protocol !== 2 || base.season !== d.season || isLive() && base.epoch !== d.epoch)) {
          if (hasDraft()) { freeze('The board changed while you had unconfirmed tiles.'); return null; }
          acknowledgements = []; disconnect();
        }
        if (isLive() && d.protocol === 2 && base.epoch === d.epoch && base.season === d.season && d.revision < base.revision) return null;
        // A snapshot is as old as its request (see beginRead) — and never older than what the
        // stream has delivered since it was asked.
        base = Object.assign({}, d); lastSync = Math.max(lastSync, ticket && safeInteger(ticket.issuedAt) ? ticket.issuedAt : Date.now()); readFailures = 0; readRetryAt = 0;
        if (ticket) acceptedRead = ticket.ordinal;
        if (isLive()) acknowledgements = acknowledgements.filter(function (a) { return a.revision > base.revision; });
        palette(); connect(); status();
        recover();
        if (isLive() && !client.presenceStarted) { client.presenceStarted = true; presence('watching'); }
        return decorated();
      },
      // A failed read backs off from the moment it was ASKED: 10, 20, 40, then 60 s, until one
      // lands. The skins do not pass the answer's Retry-After (they report only that the read
      // failed), so the backoff is blind to it; a 429 costs one attempt per window either way,
      // where before it cost one every 5 s tick for as long as the budget stayed exhausted.
      readFailed: function (ticket) {
        if (ticket && ticket.ordinal !== readOrdinal) return;
        readFailures++;
        readRetryAt = (ticket && safeInteger(ticket.issuedAt) ? ticket.issuedAt : Date.now()) + Math.min(READ_BACKOFF_MAX_MS, READ_BACKOFF_MS * Math.pow(2, readFailures - 1));
        streamReady = false; status();
        if (!frozen && !base) transportEl.textContent = 'Reconnecting · board unavailable';
      },
      edit: function (x, y) {
        if (!base || frozen || adjusting) return null;
        if (erase && (!isLive() || base.capabilities.erase !== true)) return null;
        var edit = erase ? { x: x, y: y, op: 'erase' } : { x: x, y: y, c: selected };
        expectations.set(edit, decorated().grid[y * base.w + x]);
        return edit;
      },
      changed: function () { draftNonce = null; persist(); },
      saved: function () {
        var remaining = opts.getDraft();
        // A recolour queued during our own in-flight write expects that write's resulting
        // ink, not the pre-write cell. Never substitute unrelated newer snapshot values.
        if (confirmedBatch) remaining.forEach(function (p) {
          confirmedBatch.pixels.forEach(function (sent, i) {
            if (p.x === sent.x && p.y === sent.y && confirmedBatch.body.expected && expectations.get(p) === confirmedBatch.body.expected[i]) expectations.set(p, encode(sent));
          });
        });
        confirmedBatch = null;
        if (recoveryVerifying && remaining.some(function (p) { return decorated().grid[p.y * base.w + p.x] !== expectations.get(p); })) {
          recoveryVerifying = false; draftNonce = null; persist(); freeze('The original save was verified, but another painter changed a square targeted by the remaining offline edits.'); return;
        }
        recoveryVerifying = false;
        if (!opts.getDraft().length) draftRevision = null; else draftRevision = currentRevision();
        draftNonce = null; persist();
      },
      painted: function () { client.changed(); var previous = lastPaint; lastPaint = Date.now(); if (!previous || lastPaint - previous >= 5000) presence('placing'); },
      prepare: function (pixels, actor, customer) {
        if (frozen || !base) return null;
        if (Date.now() < retryUntil) { say('The board is busy. Retry save in ' + Math.ceil((retryUntil - Date.now()) / 1000) + ' seconds. Your tiles are kept in this tab.'); return null; }
        if (heldBatch) return heldBatch;
        if (!validPixels(pixels, base.w, base.h, base.palette.length, isLive() && base.capabilities.erase === true)) { freeze('These edits are not supported by this board.'); return null; }
        var batch = { pixels: pixels, protocol: isLive() ? 2 : 1, revision: currentRevision() };
        batch.body = isLive() ? { protocol: 2, actor: actor, epoch: base.epoch, season: base.season, batchId: uuid(), issuedAt: Date.now(), pixels: pixels } : Object.assign({ actor: actor, pixels: pixels }, customer ? { cust: customer } : {});
        if (isLive() && base.capabilities.recovery === true) {
          // The durable unsent draft already has an identity: duplicate-tab recovery uses
          // that same receipt, not a new purchase of the same tile operation.
          batch.body.batchId = draftNonce || uuid(); batch.body.issuedAt = draftIssued || Date.now();
          batch.body.expected = pixels.map(function (p) { return expectations.get(p); }).join('');
          if (batch.body.expected.length !== pixels.length) { freeze('These edits are missing their original cell expectations.'); return null; }
        }
        batch.json = JSON.stringify(batch.body);
        if (isLive()) { heldBatch = batch; persist(); }
        return batch;
      },
      acknowledge: function (batch, http, reply, retryAfter) {
        if (http === 429) {
          var wait = /^\d+$/.test(String(retryAfter || '')) ? Number(retryAfter) * 1000 : Date.parse(retryAfter) - Date.now();
          retryUntil = Date.now() + (Number.isFinite(wait) && wait > 0 ? Math.min(wait, 86400000) : 60000);
        }
        var valid = http >= 200 && http < 300 && reply && reply.ok === true && reply.painted === batch.pixels.length && !reply.refused && !reply.invalid;
        if (batch.protocol === 2) {
          if (http === 426 || http === 428 || http === 409 && reply && ['canvas_season_changed', 'canvas_revision_changed', 'canvas_cells_changed', 'batch_expired', 'batch_payload_changed'].indexOf(reply.error) !== -1) { freeze('This save targets an expired board or squares changed by another painter.'); return false; }
          valid = valid && reply.protocol === 2 && reply.epoch === batch.body.epoch && reply.season === batch.body.season && reply.batchId === batch.body.batchId &&
            safeInteger(reply.revision) && reply.revision > batch.revision && reply.refused === 0 && reply.invalid === 0 && safeInteger(reply.occupied) && safeInteger(reply.totalPainted);
          if (valid) {
            if (!base || base.epoch !== reply.epoch || base.season !== reply.season) { freeze('The board changed before this save was confirmed.'); return false; }
            if (reply.revision > base.revision) acknowledgements.push({ revision: reply.revision, pixels: batch.pixels });
            confirmedBatch = batch;
            heldBatch = null;
          }
        } else if (valid) base.grid = apply(base.grid, batch.pixels, base.w);
        return !!valid;
      },
      confirmedGrid: function () { var d = decorated(); return d && d.grid; },
      hasRetry: function () { return !!heldBatch; },
      start: function () {
        setInterval(supervise, 5000);
        setInterval(function () { presence(); }, 15000);
        // The first frame is asked for through the timer like every later one: a tab born hidden
        // must not get a synchronous "frame" from a harness whose requestAnimationFrame is direct.
        if (typeof root.requestAnimationFrame === 'function') setTimeout(pulse, FRAME_EVERY_MS);
        // A real hidden/pagehide clears every proof of visibility; the browser's word wins until the
        // page proves otherwise again (a touch, or a painted frame).
        function hide() { proven = false; lastFrame = 0; presence('leave'); disconnect(); showPresence(null); }
        document.addEventListener('visibilitychange', function () { if (document.hidden) hide(); else resume(true); });
        // A resumed page may not get its visibilitychange back (assumed of iOS home-screen apps; seen
        // in headless Chrome). It does get the person's next touch, which proves the page visible
        // from then until the next hidden; pageshow/focus/online prove nothing (they fire on hidden
        // tabs too) and only resume a page that is visible on its own evidence.
        ['pointerdown', 'touchstart', 'keydown'].forEach(function (type) {
          document.addEventListener(type, function () { var was = visible(); proven = true; if (!was) resume(true); }, true);
        });
        ['pageshow', 'focus', 'online'].forEach(function (type) { root.addEventListener(type, function () { resume(false); }); });
        root.addEventListener('pagehide', function () { persist(); proven = false; lastFrame = 0; presence('leave'); disconnect(); removeTrace(); });
      }
    };
    return client;
  }

  /* ---------- BOARD GESTURES: one place for pan, pinch, wheel, tap and fling.
     2026-09-14, Josh: "can you make the mobile experience buttery smooth. is there a way to
     disable page swipe back on this page only because that keeps happening when you are just
     trying to swipe the board. can we pinch to zoom the bord too?"

     Until today each skin carried its own ~50 lines of pointer code. One finger panned; a SECOND
     finger ENDED the gesture (so there was no pinch at all); every pointermove applied the view
     straight away; and the canvas element WAS the whole board — 250*scale CSS px a side, which at
     scale 42 is a 10,500px layer times the device pixel ratio, re-laid-out on every frame of a
     drag. That is why it was not smooth, and why pinch could not simply be bolted on.

     Both skins now hand this factory their live view object, their clampView and applyView, and a
     tap callback, and get back zoomAt/active/cancel/destroy. Pointer Events only. Everything is
     measured in stage CSS px: the stage rect is read ONCE at the start of a gesture (and again on
     resize), never per move — getBoundingClientRect forces layout, and a drag is hundreds of moves.

     Rules the tests pin down (test/commission-gestures.test.mjs):
     - one pointer pans once it has moved past the slop (6px touch/pen, 3px mouse); the position is
       stored and applied at most ONCE per animation frame, whatever the event rate;
     - a second pointer starts a pinch: the board point under the starting midpoint stays under the
       moving midpoint; when one finger lifts the other keeps panning, and that gesture can never
       end as a tap;
     - a tap is one pointer, under the slop, no pinch, not cancelled — pointercancel or a lost
       capture (the OS taking the touch for a system gesture) ends the gesture with NO tap;
     - a fast release flings (velocity over the last ~100ms of moves, 0.94 decay per 16ms, an axis
       dies the moment the clamp touches it), cancelled by any pointerdown, cancel() or destroy();
       catching a moving board is not a tap either (UIScrollView rules: the touch that stops a
       deceleration is swallowed) — and prefers-reduced-motion means no fling at all;
     - wheel zooms about the cursor 1.15 per notch, ctrl+wheel (a trackpad pinch) by exp(-dy/100);
       Safari's gesture* events and the long-press contextmenu are refused so the page never zooms
       or pops a callout under a board gesture;
     - every apply that changed the scale stamps data-zoom on the stage, which is how a pinch is
       verified from a real browser without reading closure state (the pages stamp it again from
       their own applyView, so paths that set the scale directly — Fit, the keyboard — agree);
     - the pan origin and the pinch anchor follow the clamp: a finger held past a wall moves the
       board the moment it turns back, and a second finger, or the one left after a pinch, starts
       from the board's painted position, never from a candidate the clamp would have refused;
     - the apply is the page's blit, synchronous: the module already guarantees one apply per
       frame, so a page that queued ANOTHER frame from inside it painted the board one frame
       behind the overlays it moved in the same call (the aim square, the trace image).
     Only pointerdown consults enabled(): trace Adjust (or a closed plain dialog) refuses new
     gestures, and cancel() — the page passes it as cancelPointer — ends the one in flight. */
  var CONTROL = 'button,a,input,select,textarea,[role="button"]';
  function now() { var p = root.performance; return p && typeof p.now === 'function' ? p.now() : Date.now(); }
  function raf(fn) { return typeof root.requestAnimationFrame === 'function' ? root.requestAnimationFrame(fn) : root.setTimeout(fn, 16); }
  function unraf(id) { if (typeof root.cancelAnimationFrame === 'function') root.cancelAnimationFrame(id); else root.clearTimeout(id); }
  function listen(bound, target, type, fn, options) {
    if (!target || typeof target.addEventListener !== 'function') return;
    target.addEventListener(type, fn, options); bound.push([target, type, fn, options]);
  }
  function unlisten(bound) {
    bound.splice(0).forEach(function (b) { if (typeof b[0].removeEventListener === 'function') b[0].removeEventListener(b[1], b[2], b[3]); });
  }
  function gestures(stage, opts) {
    var o = opts || {};
    var minScale = o.minScale > 0 ? o.minScale : 2, maxScale = o.maxScale > 0 ? o.maxScale : 42;
    var enabled = typeof o.enabled === 'function' ? o.enabled : function () { return true; };
    var pointers = new Map(), rect = null, gesture = null, pinch = null, fling = null, latest = null, frame = 0, bound = [];
    function measure() { rect = stage.getBoundingClientRect(); }
    function local(e) { return { x: e.clientX - rect.left, y: e.clientY - rect.top }; }
    function bounded(s) { return Math.min(maxScale, Math.max(minScale, s)); }
    // The view as it will be after the pending frame — CLAMPED. A pinch that starts, or a pan that
    // re-anchors after one finger of a pinch lifts, must begin from where the board is GOING, and
    // where it is going is the pending candidate AFTER the page's clamp, not the raw finger
    // arithmetic. The 2026-09-14 gesture-math review reproduced both faults of the unclamped
    // version: a drag held 200px into a wall has a candidate 200px past the board's edge, so a
    // second finger landing before the frame zoomed about the edge instead of the fingers; and a
    // zoom-out pinch nearly always leaves its candidate outside the clamp, so the finger that stayed
    // down had a dead zone the width of the overshoot before the board moved again. On iOS Safari
    // (no rAF-aligned input) the window between a move and its frame is a whole frame, so this was
    // roughly every other fingers-in-motion transition. The clamp is the page's and works on the
    // live view, so the candidate is run through it and the painted values put back: the pending
    // frame still applies it, and tick() still sees the scale it is about to change.
    function current() {
      var view = o.getView();
      if (!latest) return view;
      var x = view.x, y = view.y, s = view.scale;
      view.x = latest.x; view.y = latest.y; view.scale = latest.scale;
      o.clamp();
      latest = { x: view.x, y: view.y, scale: view.scale };
      view.x = x; view.y = y; view.scale = s;
      return latest;
    }
    // The scale a pan candidate carries: the pending one if a pinch just ended, else the view's.
    // Not current() — that clamps, and the page's clamp reads the stage rect; a drag is hundreds of moves.
    function pendingScale() { return latest ? latest.scale : o.getView().scale; }
    function stamp(view) { stage.setAttribute('data-zoom', view.scale.toFixed(2)); }
    function settle(view, before) { o.clamp(); o.apply(); if (view.scale !== before) stamp(view); }
    function schedule() { if (!frame) frame = raf(tick); }
    function reduced() { try { return !!(root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) { return false; } }
    function tick() {
      frame = 0;
      var view = o.getView(), before = view.scale;
      if (latest) {
        var c = latest; latest = null;
        view.x = c.x; view.y = c.y; view.scale = c.scale;
        settle(view, before);
        // THE ORIGIN FOLLOWS THE CLAMP. A pan candidate is origin + finger travel, so once the finger
        // has overshot a wall the origin must move by what the clamp took away, or the finger has to
        // travel all the way back before the board moves — a 200px overshoot was a 200px dead zone
        // on the way back, the single most common "the board is stuck" moment on a phone, where
        // overshooting an edge is normal (2026-09-14 review; HEAD's inline code did the same). The
        // pinch anchor moves the same way, in board units at the scale it was computed at, so the
        // board point under the fingers when the wall stopped them is what the next frame zooms
        // about. A candidate current() already clamped moves the origin by nothing.
        if (gesture && !pinch) { gesture.ox += view.x - c.x; gesture.oy += view.y - c.y; }
        else if (pinch) { var k = view.scale / pinch.scale; pinch.x += (view.x - c.x) / k; pinch.y += (view.y - c.y) / k; }
        // One apply per frame: a fling that started under a still-pending pan waits a frame.
        if (fling) { fling.last = now(); schedule(); }
        return;
      }
      if (!fling) return;
      var t = now(), dt = t - fling.last; fling.last = t;
      // A hidden tab stops frames; on return dt would be seconds and the board would jump. And a
      // clock that did not advance (a synchronous rAF in a fixture) must still decay, or the loop
      // never ends.
      if (!(dt > 0)) dt = 16; if (dt > 100) dt = 100;
      view.x += fling.vx * dt; view.y += fling.vy * dt;
      var decay = Math.pow(0.94, dt / 16); fling.vx *= decay; fling.vy *= decay;
      var x = view.x, y = view.y;
      o.clamp();
      if (view.x !== x) fling.vx = 0; if (view.y !== y) fling.vy = 0;
      o.apply(); if (view.scale !== before) stamp(view);
      if (Math.hypot(fling.vx, fling.vy) < 0.02) fling = null; else schedule();
    }
    function zoomAt(cx, cy, f) {
      if (!(f > 0) || !isFinite(f)) return;
      var view = o.getView(), r = stage.getBoundingClientRect(), before = view.scale;
      if (latest) { view.x = latest.x; view.y = latest.y; view.scale = latest.scale; latest = null; }
      var bx = (cx - r.left - view.x) / view.scale, by = (cy - r.top - view.y) / view.scale;
      view.scale = bounded(view.scale * f);
      view.x = cx - r.left - bx * view.scale; view.y = cy - r.top - by * view.scale;
      settle(view, before);
      // A wheel notch mid-drag (mouse button held) moves the anchor; the drag continues from here.
      if (gesture && !pinch) {
        var p = pointers.get(gesture.id);
        gesture.ox = view.x; gesture.oy = view.y; if (p) { gesture.sx = p.x; gesture.sy = p.y; }
      }
    }
    function release(id) { try { stage.releasePointerCapture(id); } catch (e) {} }
    function lift(e, cancelled) {
      if (!pointers.has(e.pointerId)) return;
      pointers.delete(e.pointerId); release(e.pointerId);
      if (cancelled && gesture) gesture.cancelled = true;
      if (pinch && (e.pointerId === pinch.a || e.pointerId === pinch.b)) {
        pinch = null;
        var rest = pointers.size ? pointers.keys().next().value : null;
        if (rest !== null) {
          // Continue as a pan from the finger still down — re-anchored, no second slop.
          var q = pointers.get(rest), c = current();
          gesture.id = rest; gesture.sx = q.x; gesture.sy = q.y; gesture.ox = c.x; gesture.oy = c.y;
          gesture.moved = true; gesture.samples = [{ t: now(), x: q.x, y: q.y }];
          return;
        }
      }
      if (pointers.size) return;
      var g = gesture; gesture = null;
      if (!g) return;
      if (!g.moved && !g.pinched && !g.cancelled) { o.onTap(e.clientX, e.clientY); return; }
      if (cancelled || !g.moved || o.fling === false || reduced()) return;
      // Velocity over the last ~100ms BEFORE THE RELEASE, not before the last move: a finger that
      // stops, holds, and lifts has no velocity even though its last moves were fast.
      var t = now(), s = g.samples.filter(function (m) { return t - m.t <= 100; });
      if (s.length < 2) return;
      var first = s[0], last = s[s.length - 1], dt = last.t - first.t;
      if (!(dt > 0)) return;
      var vx = (last.x - first.x) / dt, vy = (last.y - first.y) / dt;
      if (Math.hypot(vx, vy) <= 0.3) return;
      fling = { vx: vx, vy: vy, last: t }; schedule();
    }
    listen(bound, stage, 'pointerdown', function (e) {
      // ANY pointerdown on the stage stops a fling — before the control and button checks, because
      // the zoom buttons and Recentre sit inside the stage: a tap on them during the second of
      // inertia after a fast release used to apply the zoom or the fit and then let the leftover
      // velocity carry the view off it (2026-09-14 review: "rd-zfit visibly ends off-centre").
      var caught = !!fling; fling = null;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target && e.target !== stage && typeof e.target.closest === 'function' && e.target.closest(CONTROL)) return;
      if (!enabled() || pointers.has(e.pointerId) || pointers.size >= 2) return;
      var first = pointers.size === 0;
      if (first) measure();
      var p = local(e), view = current();
      pointers.set(e.pointerId, p);
      try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      if (first) {
        gesture = { id: e.pointerId, sx: p.x, sy: p.y, ox: view.x, oy: view.y, slop: e.pointerType === 'mouse' ? 3 : 6,
          moved: caught, pinched: false, cancelled: false, samples: [{ t: now(), x: p.x, y: p.y }] };
        return;
      }
      var a = pointers.get(gesture.id);
      pinch = { a: gesture.id, b: e.pointerId, dist: Math.max(1, Math.hypot(p.x - a.x, p.y - a.y)),
        mid: { x: (a.x + p.x) / 2, y: (a.y + p.y) / 2 }, scale: view.scale, x: view.x, y: view.y };
      gesture.pinched = true; gesture.samples = [];
    });
    listen(bound, stage, 'pointermove', function (e) {
      var p = pointers.get(e.pointerId);
      if (!p || !gesture) return;
      p.x = e.clientX - rect.left; p.y = e.clientY - rect.top;
      if (pinch) {
        var a = pointers.get(pinch.a), b = pointers.get(pinch.b);
        var dist = Math.max(1, Math.hypot(b.x - a.x, b.y - a.y)), scale = bounded(pinch.scale * dist / pinch.dist), k = scale / pinch.scale;
        latest = { scale: scale, x: (a.x + b.x) / 2 - (pinch.mid.x - pinch.x) * k, y: (a.y + b.y) / 2 - (pinch.mid.y - pinch.y) * k };
        schedule(); return;
      }
      if (e.pointerId !== gesture.id) return;
      var dx = p.x - gesture.sx, dy = p.y - gesture.sy;
      if (!gesture.moved && Math.hypot(dx, dy) <= gesture.slop) return; // a click's wobble must not shift the grid under it
      gesture.moved = true;
      var t = now(); gesture.samples.push({ t: t, x: p.x, y: p.y });
      while (gesture.samples.length > 1 && t - gesture.samples[0].t > 100) gesture.samples.shift();
      latest = { scale: pendingScale(), x: gesture.ox + dx, y: gesture.oy + dy };
      schedule();
    });
    listen(bound, stage, 'pointerup', function (e) { lift(e, false); });
    listen(bound, stage, 'pointercancel', function (e) { lift(e, true); });
    listen(bound, stage, 'lostpointercapture', function (e) { lift(e, true); });
    listen(bound, stage, 'wheel', function (e) {
      e.preventDefault();
      if (!e.deltaY) return;
      zoomAt(e.clientX, e.clientY, e.ctrlKey ? Math.exp(-e.deltaY / 100) : e.deltaY < 0 ? 1.15 : 1 / 1.15);
    }, { passive: false });
    ['gesturestart', 'gesturechange', 'gestureend', 'contextmenu'].forEach(function (type) {
      listen(bound, stage, type, function (e) { e.preventDefault(); });
    });
    listen(bound, root, 'resize', function () { if (pointers.size) measure(); else rect = null; });
    function cancel() {
      pointers.forEach(function (p, id) { release(id); });
      pointers.clear(); gesture = null; pinch = null; fling = null;
      // A pending pan position still lands (the board ends where the finger last was); a frame
      // that only existed to carry the fling is dropped so nothing keeps ticking after a cancel.
      if (frame && !latest) { unraf(frame); frame = 0; }
    }
    return {
      zoomAt: zoomAt,
      active: function () { return pointers.size > 0 || !!fling; },
      cancel: cancel,
      destroy: function () { cancel(); latest = null; if (frame) { unraf(frame); frame = 0; } unlisten(bound); }
    };
  }

  /* ---------- BOARD VIEWPORT: the canvas is the STAGE's size; the board is blitted into it.
     The old model made the canvas element the whole board and let CSS scale and translate it,
     so every zoom step re-rasterised a layer up to 10,500 CSS px a side (times DPR) — the
     single reason a pinch could not be smooth on a phone. Now the page draws the W×H board
     into an OFFSCREEN canvas (source) and this paints it into a stage-sized canvas each frame
     with one drawImage: the raster cost is the stage, never the board.
     - resize(): the backing store is the stage size × min(devicePixelRatio, 3) — re-read every
       time, because a zoomed desktop window or a monitor move changes the ratio without telling
       anyone. A ResizeObserver on the stage drives it; the window resize listener is kept as the
       ratio re-check and as the fallback where ResizeObserver is missing.
     - blit(): setTransform(dpr), clear, nearest-neighbour (the smoothing flags are set on EVERY
       blit — Safari resets them when the canvas is resized), the ground under the board with a
       soft shadow only when the board is smaller than the stage, the whole source into the view
       rect, then a 1px edge on the half pixel. view.x/y are snapped to device pixels first so a
       slow pan does not shimmer.
     - request(): rAF-coalesced — for draw()/render(), which repaint the source and may ask several
       times in one frame; one blit. NOT for applyView: the gesture module already applies at most
       once per frame, from inside a frame, and a request() queued there lands one frame LATER —
       measured 2026-09-14 with both factories on one clock: the trace image and the aim square
       (moved synchronously in the same applyView) ran a frame ahead of the board on every pan,
       pinch and fling frame, detaching by 16-48px at ordinary pan speeds. The pages' applyView
       calls blit() directly. */
  function viewport(stage, canvas, opts) {
    var o = opts || {}, ctx = canvas.getContext('2d'), dpr = 1, sw = 0, sh = 0, frame = 0, observer = null, bound = [];
    var background = o.background || '#f4efe0', edge = o.edge || 'rgba(0,0,0,.25)';
    function blit() {
      var src = o.source(), size = o.getSize(), view = o.getView();
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, sw, sh);
      ctx.imageSmoothingEnabled = ctx.webkitImageSmoothingEnabled = ctx.mozImageSmoothingEnabled = ctx.msImageSmoothingEnabled = false;
      if (!src || !size || !(size.w > 0) || !(size.h > 0) || !(sw > 0) || !(sh > 0)) return;
      var x = Math.round(view.x * dpr) / dpr, y = Math.round(view.y * dpr) / dpr, w = size.w * view.scale, h = size.h * view.scale;
      ctx.fillStyle = background;
      if (w < sw || h < sh) { ctx.save(); ctx.shadowBlur = 24; ctx.shadowColor = 'rgba(0,0,0,.25)'; ctx.fillRect(x, y, w, h); ctx.restore(); }
      else ctx.fillRect(x, y, w, h);
      ctx.drawImage(src, 0, 0, size.w, size.h, x, y, w, h);
      ctx.strokeStyle = edge; ctx.lineWidth = 1; ctx.strokeRect(x + 0.5, y + 0.5, w - 1, h - 1);
    }
    function resize() {
      dpr = Math.min(root.devicePixelRatio || 1, 3);
      var r = stage.getBoundingClientRect(); sw = r.width; sh = r.height;
      canvas.width = Math.round(sw * dpr); canvas.height = Math.round(sh * dpr);
      canvas.style.width = '100%'; canvas.style.height = '100%';
      blit();
    }
    function request() { if (!frame) frame = raf(function () { frame = 0; blit(); }); }
    if (typeof root.ResizeObserver === 'function') {
      try { observer = new root.ResizeObserver(function () { resize(); }); observer.observe(stage); } catch (e) { observer = null; }
    }
    listen(bound, root, 'resize', resize);
    resize();
    return {
      resize: resize, blit: blit, request: request,
      destroy: function () { if (observer) observer.disconnect(); observer = null; unlisten(bound); if (frame) { unraf(frame); frame = 0; } }
    };
  }
  root.WCCommission = { create: create, gestures: gestures, viewport: viewport, decode: decode, encode: encode, apply: apply, snapshot: snapshot, alphabet: ALPHABET };
})(window);
